import type { TripDetails, TripPosition } from '../api'

export const LIVE_TRIP_POLL_INTERVAL_MS = 5_000
export const LIVE_TRIP_MAX_POLL_INTERVAL_MS = 10_000

export function nextLiveTripPollInterval(_current: number, _hasNewPositions: boolean): number {
  return LIVE_TRIP_POLL_INTERVAL_MS
}

function positionKey(position: TripPosition): string {
  return position.id || `${position.recordedAt}:${position.latitude}:${position.longitude}`
}

export function latestPositionId(positions: TripPosition[], fallback = ''): string {
  return positions.reduce((latest, position) => {
    if (!position.id) return latest
    if (/^\d+$/.test(position.id) && /^\d+$/.test(latest)) {
      return BigInt(position.id) > BigInt(latest) ? position.id : latest
    }
    return position.id
  }, fallback)
}

export function mergeTripRefresh(current: TripDetails, refresh: TripDetails): TripDetails {
  const knownPositions = new Set(current.positions.map(positionKey))
  const newPositions = refresh.positions.filter((position) => {
    const key = positionKey(position)
    if (knownPositions.has(key)) return false
    knownPositions.add(key)
    return true
  })

  return {
    ...current,
    ...refresh,
    platform: refresh.platform ?? current.platform,
    views: refresh.views ?? current.views,
    positions: [...current.positions, ...newPositions],
  }
}
